import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import {
  divisionDisplayName,
  selectAllDivisions,
  useGetDivisionsOnMount,
} from '@user/store/divisions'
import { SelectItem } from '../typings'

export function useDivisions() {
  const status = useGetDivisionsOnMount()

  const loading = status === 'pending'

  const divisions = useSelector(selectAllDivisions)

  const formattedDivisions = useMemo<SelectItem[]>(
    () =>
      divisions.map((d) => ({
        label: divisionDisplayName(d),
        value: d.id,
      })),
    [divisions],
  )

  return [loading, formattedDivisions] as const
}
